import Vue from "vue";
import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import { CustomerHelper } from "../crm/helpers/customerHelper";
import { GuidelineApi, CardGuideline, DayDone } from "../components/guidelines/guidelineApi";

const InProgress = 2;

export interface TodayData {
  today: string;
  rows: any[];
  bookings: any[];
  surveys: any[];
  programs: any[];
  programByGuideline: { [id: number]: string };
}

// Everything of the day (D35): today's appointments, pending questionnaires and the guidelines to mark, plus the
// programs in progress. No new backend: it joins what bookings, surveys, guidelines and programs already return.
export class TodayLoader {
  static async load(): Promise<TodayData> {
    const customer = CustomerHelper.getStoredCustomer();
    const out: TodayData = { today: "", rows: [], bookings: [], surveys: [], programs: [], programByGuideline: {} };
    if (!customer) return out;
    const crud = new CrudService();
    const [guidelines, bookings, surveys, programs] = await Promise.all([
      GuidelineApi.list(),
      crud.httpGet(`${Settings.HostName}/api/publicbookings/customer-bookings/${customer}/today`),
      crud.httpGet(`${Settings.HostName}/api/publiccustomersurveys/customer-surveys/${customer}`),
      crud.httpGet(`${Settings.HostName}/api/publicprogrampacks/customer/${customer}`),
    ]);
    if (guidelines && guidelines.ok) {
      out.today = GuidelineApi.day(guidelines.today);
      out.rows = guidelines.data;
    }
    if (bookings && bookings.ok) {
      out.bookings = bookings.data;
    }
    if (Array.isArray(surveys)) {
      out.surveys = surveys.filter((s: any) => s.answeredDate === null && s.token);
    }
    if (programs && programs.ok) {
      out.programs = programs.data.filter((e: any) => e.status === InProgress);
      programs.data.forEach((e: any) => e.columns.forEach((c: any) => c.cards
        .filter((k: any) => k.cardType === CardGuideline && k.customerGuidelineId)
        .forEach((k: any) => Vue.set(out.programByGuideline, k.customerGuidelineId, e.name))));
    }
    return out;
  }

  static count(data: TodayData): number {
    return data.rows.length + data.bookings.length + data.surveys.length;
  }

  static done(data: TodayData): number {
    return data.rows.filter((r: any) => r.todayStatus === DayDone).length;
  }
}
